export const API_URL = `${process.env.VUE_APP_API_URL}` || "/api";
export const API_VERSION = `${process.env.VUE_APP_API_VERSION}` || "v0";
export const API_ENDPOINT = `${API_URL}/${API_VERSION}`;
export const COGNITO_DOMAIN = process.env.VUE_APP_COGNITO_DOMAIN || "";
export const COGNITO_REDIRECT_URI = process.env.VUE_APP_COGNITO_REDIRECT_URI || "";
export const GA_MEASUREMENT_ID = process.env.VUE_APP_GA_MEASUREMENT_ID;

export const PUBLIC_USERS_ENDPOINT = "/public/users";
export const USERS_ME_ENDPOINT = "/users/me";
export const GROUPS_ENDPOINT = "/users/me/groups";
export const PLAYERS_ENDPOINT = "/players";
export const PLAYERS_ME_ENDPOINT = "/players/me";
export const COMPETITIONS_ENDPOINT = "/competitions";
export const RULES_ENDPOINT = "/rules";
export const TEAMS_ENDPOINT = "/teams";
export const UPDATE_AVATAR_OPERATION = ":updateAvatar";

export const ADMIN_GROUPS_ENDPOINT = "/groups";
export const ADMIN_COMPETITIONS_ENDPOINT = "/competitions";

export const TIMEOUT_MESSAGE_INFO = 3000;

export const MANUAL_PDF = "https://cdn.porrita.online/porrita-online/docs/default/guide.pdf";
export const CURRENT_USER_REFRESH = 30000;
export const MAX_FILE_SIZE = 500000;
export const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/png"];

export const VERSION = "0.1.0";

export const URL_GROUP_BETTER_TELEGRAM = "https://t.me/+_nR29RAHr5oxNjI0";
